import { ChangeDetectionStrategy, Component, OnInit, signal } from '@angular/core';
import { IAzureFoodSearchItem, IAzureSearchInput, IAzureSearchResponse } from 'lib/search/search.models';
import { ISearchInputResult } from 'lib/ui/form-inputs';
import { ListItem } from 'lib/ui/list';
import { map, Observable } from 'rxjs';
import { TypeCoreComponent } from 'src/app/pages/type-routes/type-core.component.js';
import { foodHelper } from './food.helper';

@Component({
	templateUrl: './list-global-foods.component.html',
	selector: 'mod-global-my-foods',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class ListGlobalFoodsComponent extends TypeCoreComponent implements OnInit {
	private readonly searchFoods: (data: IAzureSearchInput) => Observable<IAzureSearchResponse<IAzureFoodSearchItem>> =
		(data) => this.dependencies.azureSearchService.searchFoodItems(data);

	public readonly azureSearchItems = signal<ListItem<any>[]>([]);
	public readonly azureSearchItemsLoaded = signal<boolean>(false);

	constructor() {
		super();

		this.dataInit = () => {
			this.initFoods();
		};
	}

	private initFoods(): void {
		this.searchViaAzure();
	}

	handleAzureSeach(search: ISearchInputResult): void {
		this.searchViaAzure(search.search);
	}

	handleSelectAzureSearchItem(item: ListItem<IAzureFoodSearchItem>): void {}

	private searchViaAzure(search?: string): void {
		super.subscribeToObservable(
			this.searchFoods({ search: search, page: 1, pageSize: 50 }).pipe(
				map((response) => {
					this.azureSearchItems.set(
						response.items.map((m) => {
							const graph = foodHelper.getFoodSearchItemNutritionGraphConfig(m);
							const listItem: ListItem<IAzureFoodSearchItem> = {
								data: m,
								id: m.id,
								title: m.name,
								subtitle: m.category,
								pieGraph: {
									singleSeries: graph.singleSeries,
									colorScheme: graph.colorScheme
								}
							};

							return listItem;
						})
					);

					this.azureSearchItemsLoaded.set(true);
				})
			)
		);
	}
}
